// Password rules for NEW accounts (sign-up). Shared with the client (copied by `npm run sync-shared`), so the
// register form and the API agree. Login never checks these: existing accounts keep working.
export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 256;

// Grapheme clusters (what the user sees as one character), with Intl.Segmenter where available (Node 16+,
// all current browsers). Fallback: code points, not counting combining marks.
const Segmenter: any = typeof Intl !== "undefined" ? (Intl as any).Segmenter : undefined;
const graphemes = Segmenter ? new Segmenter(undefined, {granularity: "grapheme"}) : null;

/**
 * Length in characters as the user sees them (grapheme clusters): an emoji counts as 1 (not 2 UTF-16 units),
 * and "é" typed as e + a combining accent counts as 1, not 2.
 */
export function passwordLength(password: string): number {
    // Array.from, not for-of: the client is compiled to ES5 without downlevelIteration
    if (graphemes) return Array.from(graphemes.segment(password) as Iterable<unknown>).length;
    return Array.from(password.replace(/\p{M}/gu, "")).length;
}

export function passwordProblem(password: string): string | null {
    const length = passwordLength(password);
    if (length < PASSWORD_MIN) return `Password must be at least ${PASSWORD_MIN} characters long`;
    if (length > PASSWORD_MAX) return `Password must be at most ${PASSWORD_MAX} characters long`;
    return null;
}
